// extracted by mini-css-extract-plugin
module.exports = {"bar":"BarPromotion_bar__hs9TF","isScrolled":"BarPromotion_isScrolled__VEWlV","boxReduction":"BarPromotion_boxReduction__MiX1L","boxAction":"BarPromotion_boxAction__GGKCw"};